module.exports = __webpack_public_path__ + "img/单据处理配置.341a2ffe.svg";